<template>
  <div class="check-container">
    <div class="check-and-label">
      <label class="switch">
        <input
          type="checkbox"
          :checked="isChecked"
          @change="toggle"
        />
        <span class="slider" />
      </label>
      <div class="label"><slot /></div>
    </div>
    <div v-if="description" class="description">{{ description }}</div>
  </div>
</template>

<script>
export default {
  name: 'Check',
  props: {
    value: {
      type: [Boolean, Array, Number],
      required: true
    },
    optionValue: {
      type: [String, Number, Boolean],
      default: true
    },
    description: {
      type: String,
      default: ''
    }
  },
  computed: {
    isChecked() {
      if (Array.isArray(this.value)) {
        return this.value.includes(this.optionValue);
      }
      return this.value;
    }
  },
  methods: {
    toggle() {
      let newValue;

      if (Array.isArray(this.value)) {
        const exists = this.value.includes(this.optionValue);
        newValue = exists
          ? this.value.filter(v => v !== this.optionValue)
          : [...this.value, this.optionValue];
      } else {
        newValue = !this.value;
      }

      this.$emit('input', newValue);
      this.$emit('update:modelValue', newValue);
      this.$emit('change', newValue);
    }
  }
};
</script>

<style scoped>
.check-container {
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 1.3;
}

.check-and-label {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex-shrink: 0;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

.slider::before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  top: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .slider {
  background-color: #007bff;
}

input:checked + .slider::before {
  transform: translateX(18px);
}

.label {
  font-weight: 600;
}

.description {
  font-size: 14px;
  color: #6c757d;
}
</style>